class SearchGender extends window.BAO.CustomElement() {
  constructor () {
    super()
    this.setGender = this.setGender.bind(this)
  }

  setupListeners () {
    super.setupListeners()

    this.els.gender?.elements.forEach(el => {
      this.listeners.add(el, 'click', this.setGender.bind(this))
    })
  }

  setGender (ev) {
    const targetEL = ev.target.closest(this.els.gender?.selector)

    if (targetEL) {
      const gender = targetEL.dataset.gender?.trim()
      const allowedValues = ['male', 'female']

      if (allowedValues.includes(gender)) {
        window.BAO.Cart.updateCartAttributes({ gender })
        sessionStorage.setItem('gender', gender)
      }
    }
  }
}

if (!customElements.get('search-gender')) {
  customElements.define('search-gender', SearchGender)
}
